import { PagedResult } from "../PagedResult";

export function getStartIndex<T>(result: PagedResult<T>): number {
  return (result.pageNumber - 1) * result.pageSize + 1;
}

export function getEndIndex<T>(result: PagedResult<T>): number {
  let endIndex = result.pageNumber * result.pageSize;
  if (endIndex > result.totalCount) {
    endIndex = result.totalCount;
  }
  return endIndex;
}
